export enum Types {
  RequestLogin = 'REQUEST_LOGIN',
  LoginSuccess = 'LOGIN_SUCCESS',
  LoginError = 'LOGIN_ERROR',
  Refresh = 'REFRESH',
  LogOut = 'LOGOUT'
}

type RequestAction = {
  type: Types.RequestLogin;
  payload: {
    isLoading: boolean;
    status: string;
  };
};

type LoginSuccessAction = {
  type: Types.LoginSuccess;
  payload: {
    sub: string;
    role: string;
    uuid: string;
    isAuthenticated: boolean;
    isLoading: boolean;
    isError: boolean;
    status: string;
  };
};

type LoginErrorAction = {
  type: Types.LoginError;
  payload: {
    error: string;
    isLoading: boolean;
    isError: boolean;
    status: string;
  };
};

type RefreshAction = {
  type: Types.Refresh;
  payload: {
    sub: string;
    role: string;
    uuid: string;
    isAuthenticated: boolean;
    isLoading: boolean;
    isError: boolean;
    status: string;
  };
};

type LogOutAction = {
  type: Types.LogOut;
};

export type UserInfoProps = {
  sub?: string;
  role?: string;
  uuid?: string;
  error?: string;
  isAuthenticated?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  status?: string;
};

export type AuthenticationState = {
  user: UserInfoProps;
};

export type AuthenticationAction =
  | RequestAction
  | LoginSuccessAction
  | LoginErrorAction
  | RefreshAction
  | LogOutAction;

export const AuthReducer = (state: AuthenticationState, action: AuthenticationAction) => {
  switch (action.type) {
    case Types.RequestLogin:
      return {
        ...state,
        user: {
          isLoading: true,
          status: 'loading'
        }
      };
    case Types.LoginSuccess:
      return {
        ...state,
        user: {
          sub: action.payload.sub,
          role: action.payload.role,
          uuid: action.payload.uuid,
          isAuthenticated: action.payload.isAuthenticated,
          isLoading: action.payload.isLoading,
          isError: action.payload.isError,
          status: action.payload.status
        }
      };
    case Types.LoginError:
      return {
        ...state,
        user: {
          isLoading: action.payload.isLoading,
          error: action.payload.error,
          isError: action.payload.isError,
          status: action.payload.status
        }
      };
    case Types.Refresh:
      return {
        ...state,
        user: {
          sub: action.payload.sub,
          role: action.payload.role,
          uuid: action.payload.uuid,
          isAuthenticated: action.payload.isAuthenticated,
          isLoading: action.payload.isLoading,
          isError: action.payload.isError,
          status: action.payload.status
        }
      };
    case Types.LogOut:
      return {
        ...state,
        user: {}
      };
    default:
      return state;
  }
};
